var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.layerClass,on:{"click":_vm.handleClick}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.iconPath())}})])
}
var staticRenderFns = []

export { render, staticRenderFns }